import { render, staticRenderFns } from "./DetailProductComponent.vue?vue&type=template&id=aca069f4&scoped=true"
import script from "./DetailProductComponent.vue?vue&type=script&lang=js"
export * from "./DetailProductComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailProductComponent.vue?vue&type=style&index=0&id=aca069f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca069f4",
  null
  
)

export default component.exports